"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TasksGlobal;
exports.buildTree = buildTree;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ContractContext_1 = require("../Contracts/ContractsList/ContractContext");
const ContractsController_1 = require("../Contracts/ContractsList/ContractsController");
const ToolsDate_1 = __importDefault(require("../React/Tools/ToolsDate"));
const ScrumTaskRow_1 = __importDefault(require("../Scrumboard/CurrentSprint/ScrumTaskRow"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../View/Resultsets/FilterableTable/FilterableTable"));
const BussinesObjectSelectors_1 = require("../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const CaseStatusFilter_1 = require("../View/Modals/CommonFormComponents/CaseStatusFilter");
const CaseModalButtons_1 = require("./Modals/Case/CaseModalButtons");
const ContractModalButtons_1 = require("./Modals/ContractModalButtons");
const CaseListSheetButton_1 = require("./Modals/CaseListSheetButton");
const MilestoneModalButtons_1 = require("./Modals/Milestone/MilestoneModalButtons");
const ProjectModalButtons_1 = require("./Modals/ProjectModalButtons");
const ProjectCaseListSheetButton_1 = require("./Modals/ProjectCaseListSheetButton");
const TasksGlobalModalButtons_1 = require("./Modals/TasksGlobalModalButtons");
const CaseInlineStatusDropdown_1 = __importDefault(require("./CaseInlineStatusDropdown"));
const MilestoneInlineStatusDropdown_1 = __importDefault(require("./MilestoneInlineStatusDropdown"));
const ProjectsFilterBody_1 = require("./ProjectsFilterBody");
require("./TasksGlobal.css");
const TasksGlobalController_1 = require("./TasksGlobalController");
const TasksGlobalFilterBody_1 = require("./TasksGlobalFilterBody");
function TasksGlobal() {
    //const [tasks, setTasks] = useState([] as Task[] | undefined); //undefined żeby pasowało do typu danych w ContractProvider
    const [contractsWithChildren, setContractsWithCildren] = (0, react_1.useState)([]);
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    const [dataLoaded, setDataLoaded] = (0, react_1.useState)(true);
    const [selectedProject, setSelectedProject] = (0, react_1.useState)(undefined);
    const [scrollTrigger, setScrollTrigger] = (0, react_1.useState)(0);
    const pendingScrollIdRef = (0, react_1.useRef)(null);
    const filterVersionRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        document.title = "Projekty i Zadania";
    }, []);
    (0, react_1.useEffect)(() => {
        if (!selectedProject)
            return;
        async function fetchData() {
            setDataLoaded(false);
            const [contractsWithChildren] = await Promise.all([
                TasksGlobalController_1.contractsWithChildrenRepository.loadItemsFromServerPOST([
                    {
                        _project: selectedProject,
                        statusType: "active",
                    },
                ]),
                ContractsController_1.caseTypesRepository.loadItemsFromServerPOST(),
                ContractsController_1.milestoneTypesRepository.loadItemsFromServerPOST(),
            ]);
            setContractsWithCildren(contractsWithChildren);
            setExternalUpdate((prevState) => prevState + 1);
            setDataLoaded(true);
        }
        fetchData();
    }, [selectedProject]);
    // Osoby do okna „Spis spraw" projektu — z pełnego (nieprzefiltrowanego) drzewa
    // wybranego projektu, więc filtr „osoba = X" nie okroi listy do jednej osoby.
    const projectTaskOwners = (0, react_1.useMemo)(() => ({
        projectId: selectedProject?.id,
        owners: collectTaskOwners(contractsWithChildren.flatMap((c) => c.milestonesWithCases || [])),
    }), [contractsWithChildren, selectedProject?.id]);
    function makeTaskParentsLabel(task) {
        const _contract = task._parent._parent._contract;
        const _milestone = task._parent._parent;
        const _case = task._parent;
        const ourId = "ourId" in _contract ? _contract.ourId : undefined;
        return (`${ourId || ""} ${_contract.alias || ""} ${_contract.number || ""} | ` +
            `${_milestone._FolderNumber_TypeName_Name || ""} |` +
            `${_case._type.name || ""} | ${_case.name || ""}`);
    }
    (0, react_1.useEffect)(() => {
        if (!pendingScrollIdRef.current)
            return;
        const targetId = pendingScrollIdRef.current;
        const timeoutId = setTimeout(() => {
            const el = document.getElementById(targetId);
            if (el) {
                const navbarHeight = document.querySelector("nav.sticky-top")?.getBoundingClientRect().height ?? 0;
                const y = el.getBoundingClientRect().top + window.scrollY - navbarHeight - 8;
                window.scrollTo({ top: y, behavior: "smooth" });
                el.classList.remove("section-scroll-highlight");
                void el.offsetWidth; // force reflow so animation restarts if triggered twice
                el.classList.add("section-scroll-highlight");
                el.addEventListener("animationend", () => el.classList.remove("section-scroll-highlight"), { once: true });
            }
            pendingScrollIdRef.current = null;
        }, 100);
        return () => clearTimeout(timeoutId);
    }, [scrollTrigger]);
    async function handleSubmitTasksSections(criteria) {
        if (!selectedProject)
            return buildTree(contractsWithChildren, undefined, undefined, { caseStatuses: CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER });
        const targetCaseId = criteria._case?.id;
        // _case, caseStatuses i taskStatuses są obsługiwane wyłącznie frontendowo
        // (collapse/scroll, filtr drzewa) — nie trafiają do backendu
        const { _case: _unused, caseStatuses: caseStatusesRaw, taskStatuses: taskStatusesRaw, ...backendCriteria } = criteria;
        // Pusty wybór ⇒ powrót do domyślnego filtra (Na zaś + W trakcie), a nie "pokaż wszystko"
        const caseStatuses = caseStatusesRaw?.length
            ? caseStatusesRaw
            : CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER;
        // Domyślnie wszystkie statusy zadań — pusty/pełny wybór ⇒ brak filtrowania zadań
        const taskStatuses = taskStatusesRaw?.length
            ? taskStatusesRaw
            : undefined;
        const [filteredContractsWithChildren] = await Promise.all([
            TasksGlobalController_1.contractsWithChildrenRepository.loadItemsFromServerPOST([
                {
                    ...backendCriteria,
                    _project: selectedProject,
                    statusType: backendCriteria.statuses?.length ? undefined : "active",
                },
            ]),
        ]);
        let version;
        if (targetCaseId) {
            version = ++filterVersionRef.current;
            pendingScrollIdRef.current = `case${targetCaseId}_v${version}`;
            setScrollTrigger((t) => t + 1);
        }
        return buildTree(filteredContractsWithChildren, targetCaseId, version, {
            caseStatuses,
            taskStatuses,
            // Lista osób w oknie "Spis spraw" musi pochodzić z pełnego drzewa projektu:
            // po filtrze "osoba = X" przefiltrowane drzewo zna już tylko tę jedną osobę.
            taskOwnersSource: contractsWithChildren,
        });
    }
    function handleResetTasksSections() {
        return buildTree(contractsWithChildren, undefined, undefined, { caseStatuses: CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER });
    }
    return (react_1.default.createElement(ContractContext_1.ContractProvider, { project: selectedProject },
        react_1.default.createElement(react_bootstrap_1.Container, { fluid: true },
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { md: "3" },
                    react_1.default.createElement(ProjectCaseListSheetButton_1.ProjectTaskOwnersContext.Provider, { value: projectTaskOwners },
                        react_1.default.createElement(FilterableTable_1.default, { id: "projects", title: "Projekty", repository: TasksGlobalController_1.projectsRepository, showTableHeader: false, AddNewButtonComponents: [ProjectModalButtons_1.ProjectAddNewModalButton], FilterBodyComponent: ProjectsFilterBody_1.ProjectsFilterBody, resetCriteria: { status: "ACTIVE" }, EditButtonComponent: ProjectModalButtons_1.ProjectEditModalButton, RowActionMenuComponents: projectRowActionMenuComponents, tableStructure: [
                                {
                                    header: "Nazwa",
                                    renderTdBody: (project) => react_1.default.createElement(react_1.default.Fragment, null, project._ourId_Alias),
                                    colLg: 11,
                                },
                            ], onRowClick: setSelectedProject }))),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "9" }, !selectedProject ? (react_1.default.createElement(NoProjectSelectedMessage, null)) : !dataLoaded ? (react_1.default.createElement(LoadingMessage, { selectedProject: selectedProject })) : (react_1.default.createElement(FilterableTable_1.default, { id: `tasks_${selectedProject.id}`, title: "Zadania", showTableHeader: false, repository: TasksGlobalController_1.tasksGlobalRepository, FilterBodyComponent: TasksGlobalFilterBody_1.TasksGlobalFilterBody, EditButtonComponent: TasksGlobalModalButtons_1.TaskEditModalButton, initialSections: buildTree(contractsWithChildren, undefined, undefined, {
                        caseStatuses: CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER,
                    }), snapshotMode: "criteria-only", sectionsFilterHandlers: {
                        onSubmitSections: handleSubmitTasksSections,
                        onResetSections: handleResetTasksSections,
                    }, tableStructure: [
                        {
                            header: "Zadania",
                            renderTdBody: (task, isActive) => (react_1.default.createElement(ScrumTaskRow_1.default, { task: task, isActive: isActive })),
                            colLg: 11,
                        },
                    ], externalUpdate: externalUpdate })))))));
}
function NoProjectSelectedMessage() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h3", null, "Wybierz projekt"),
        react_1.default.createElement("p", { className: "text-muted" }, "Kliknij na projekt z listy po lewej stronie, aby zobaczy\u0107 zadania.")));
}
function LoadingMessage({ selectedProject }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, " \u0141aduj\u0119 zadania dla projektu:"),
        react_1.default.createElement("h3", null, selectedProject?._ourId_Alias),
        react_1.default.createElement("p", null, selectedProject?.name),
        react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null)));
}
function truncateText(text, maxLength) {
    if (!text)
        return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
}
function makeOurContractTitleHeader(contract) {
    const contractName = truncateText(contract.name, 200);
    const hasAlias = !!contract.alias;
    const hasDates = contract.startDate || contract.endDate;
    const manager = contract._manager;
    return (react_1.default.createElement("div", { className: "d-flex flex-column gap-2" },
        react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
            react_1.default.createElement("span", { className: "contract-id" },
                contract.ourId,
                hasAlias && ` | ${contract.alias}`),
            react_1.default.createElement(CommonComponents_1.ContractStatusBadge, { status: contract.status, className: "contract-status-badge" })),
        react_1.default.createElement("h6", { className: "contract-title" }, contractName),
        react_1.default.createElement("div", { className: "contract-metadata d-flex flex-wrap gap-4 align-items-center" },
            hasDates && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCalendarAlt, className: "contract-metadata-icon" }),
                react_1.default.createElement("span", null,
                    contract.startDate ? ToolsDate_1.default.dateYMDtoDMY(contract.startDate) : "?",
                    " \u2014",
                    " ",
                    contract.endDate ? ToolsDate_1.default.dateYMDtoDMY(contract.endDate) : "?"))),
            manager && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUser, className: "contract-metadata-icon" }),
                react_1.default.createElement("span", null,
                    manager.name,
                    " ",
                    manager.surname))))));
}
function makeOtherContractTitleHeader(contract) {
    const ourRelatedId = contract._ourContract ? contract._ourContract.ourId : "Brak powiązania";
    const identifier = `${contract._type.name} ${contract.number} ➔ ${ourRelatedId}`; // NO alias — alias lives in the hero
    const contractName = truncateText(contract.name, 200);
    const contractorNames = (contract._contractors ?? []).map((c) => c.name);
    const heroParts = [contract.alias, ...contractorNames].filter(Boolean);
    const hasAnchor = heroParts.length > 0;
    // Hero z jasnym, cienkim separatorem „·" (jak na zatwierdzonej makiecie B2-a):
    // separator ma być delikatny i NIE dziedziczyć pogrubienia hero, aby wizualnie
    // oddzielać alias od wykonawcy. Fallback (brak kotwicy) => sama nazwa kontraktu.
    const heroNodes = hasAnchor
        ? heroParts.flatMap((part, idx) => idx === 0
            ? [react_1.default.createElement(react_1.default.Fragment, { key: `p${idx}` }, part)]
            : [
                react_1.default.createElement("span", { key: `s${idx}`, className: "contract-hero-sep" }, " · "),
                react_1.default.createElement(react_1.default.Fragment, { key: `p${idx}` }, part),
            ])
        : contractName;
    const hasDates = contract.startDate || contract.endDate;
    const manager = contract._ourContract?._manager;
    return (react_1.default.createElement("div", { className: "d-flex flex-column gap-2" },
        react_1.default.createElement("div", { className: "d-flex align-items-center flex-wrap gap-2" },
            react_1.default.createElement("span", { className: "contract-hero" }, heroNodes),
            react_1.default.createElement(CommonComponents_1.ContractStatusBadge, { status: contract.status, className: "contract-status-badge" })),
        react_1.default.createElement("span", { className: "contract-id" }, identifier),
        hasAnchor && react_1.default.createElement("div", { className: "contract-name-demoted" }, contractName),
        react_1.default.createElement("div", { className: "contract-metadata d-flex flex-wrap gap-4 align-items-center" },
            hasDates && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCalendarAlt, className: "contract-metadata-icon" }),
                react_1.default.createElement("span", null,
                    contract.startDate ? ToolsDate_1.default.dateYMDtoDMY(contract.startDate) : "?",
                    " \u2014",
                    " ",
                    contract.endDate ? ToolsDate_1.default.dateYMDtoDMY(contract.endDate) : "?"))),
            manager && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUser, className: "contract-metadata-icon" }),
                react_1.default.createElement("span", null,
                    manager.name,
                    " ",
                    manager.surname))))));
}
function makeContractTitleHeader(contract) {
    const isOurContract = "ourId" in contract;
    return isOurContract
        ? makeOurContractTitleHeader(contract)
        : makeOtherContractTitleHeader(contract);
}
function contractNodeEditHandler(node) {
    console.log("contractNodeEditHandler", node);
    const contract = {
        ...node.dataItem,
    };
    node.title = makeContractTitleHeader(contract);
}
function milestoneNodeEditHandler(node) {
    console.log("milestoneNodeEditHandler", node);
    const milestone = {
        ...node.dataItem,
    };
    node.title = react_1.default.createElement(react_1.default.Fragment, null, makeMilestoneTitleLabel(milestone));
}
function makeMilestoneTitleLabel(milestone) {
    // filter(Boolean): kamienie-koszyki (Oferty/Sprawy ogólne) nie mają typu — pomijamy puste człony,
    // żeby nie wyświetlać "undefined". Dla normalnych kamieni wynik jest identyczny.
    const titleText = `Kamień: ${[milestone._type._folderNumber, milestone._type.name, milestone.name]
        .filter(Boolean)
        .join(" ")}`;
    return (react_1.default.createElement("div", { className: "d-flex gap-3 align-items-center justify-content-between" },
        react_1.default.createElement("div", { className: "d-flex flex-column gap-1" },
            react_1.default.createElement("span", null,
                titleText,
                react_1.default.createElement(BussinesObjectSelectors_1.UniquenessIcon, { isUnique: milestone._type.isUniquePerContract })),
            milestone._dates && milestone._dates.length > 0 && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2 text-secondary small", style: { lineHeight: "1" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCalendarAlt, className: "text-muted" }),
                milestone._dates.map((d, index) => {
                    const startDate = d.startDate ? d.startDate.toString().split("T")[0] : "⚠️ brak daty";
                    const endDate = d.endDate ? d.endDate.toString().split("T")[0] : "⚠️ brak daty";
                    return (react_1.default.createElement("span", { key: index },
                        startDate,
                        " - ",
                        endDate));
                })))),
        react_1.default.createElement("div", null, milestone.status && react_1.default.createElement(MilestoneInlineStatusDropdown_1.default, { milestone: milestone }))));
}
function makeCaseTitleLabel(caseItem, isInTypeFolder = false) {
    const isParentCase = Boolean(caseItem._type._allowsSubCases) && !caseItem.parentCaseId;
    // W folderze typu nazwa typu jest już w nagłówku folderu — pokazujemy tylko numer i nazwę sprawy
    const label = isInTypeFolder
        ? `${caseItem._displayNumber || ""} ${caseItem.name || ""}`.trim()
        : `Sprawa: ${caseItem._typeFolderNumber_TypeName_Number_Name || ""}`;
    return (react_1.default.createElement("div", { className: "d-flex gap-3 align-items-center justify-content-between" },
        react_1.default.createElement("span", null,
            label,
            react_1.default.createElement(BussinesObjectSelectors_1.UniquenessIcon, { isUnique: caseItem._type.isUniquePerMilestone }),
            isParentCase && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSitemap, className: "ms-1 text-primary", size: "sm", title: "Sprawa mo\u017Ce mie\u0107 podsprawy" }))),
        react_1.default.createElement("div", null, caseItem.status && react_1.default.createElement(CaseInlineStatusDropdown_1.default, { caseItem: caseItem }))));
}
function makeCaseTypeTitleLabel(caseType) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolderOpen, className: "me-2 text-warning" }),
        `${caseType.folderNumber} ${caseType.name}`));
}
/** true jeśli węzeł lub którekolwiek dziecko ma przypisane zadania (leaves) */
function nodeHasTasks(node) {
    if (node.leaves && node.leaves.length > 0)
        return true;
    return (node.children || []).some(nodeHasTasks);
}
/** Ustawia initialExpanded=false na gałęziach bez zadań (rekurencyjnie) */
function collapseEmptyBranches(node) {
    if (!nodeHasTasks(node))
        node.initialExpanded = false;
    (node.children || []).forEach(collapseEmptyBranches);
}
/**
 * true jeśli sprawa spełnia filtr statusów. `caseStatuses` pominięty ⇒ brak filtrowania.
 * Sprawy bez statusu (dane sprzed migracji) są zawsze pokazywane.
 * Sprawa wskazana do nawigacji (`targetCaseId`) jest zawsze widoczna — inaczej wybór
 * zamkniętej sprawy w selektorze skutkowałby cichą nieudaną nawigacją.
 */
function caseMatchesStatusFilter(caseItem, caseStatuses, targetCaseId) {
    if (targetCaseId !== undefined && caseItem.id === targetCaseId)
        return true;
    if (!caseStatuses)
        return true;
    if (!caseItem.status)
        return true;
    return caseStatuses.includes(caseItem.status);
}
/**
 * true jeśli zadanie spełnia filtr statusów. `taskStatuses` pominięty ⇒ brak filtrowania.
 * Zadania bez statusu są zawsze pokazywane.
 */
function taskMatchesStatusFilter(task, taskStatuses) {
    if (!taskStatuses)
        return true;
    if (!task.status)
        return true;
    return taskStatuses.includes(task.status);
}
// Stałe tablice: nowa przy każdym renderze przerysowywałaby akcje wiersza bez powodu.
const contractRowActionMenuComponents = [CaseListSheetButton_1.CaseListSheetButton];
const projectRowActionMenuComponents = [ProjectCaseListSheetButton_1.ProjectCaseListSheetButton];
/**
 * Właściciele zadań w kontrakcie — lista osób w oknie "Spis spraw". Liczona z drzewa,
 * żeby nie dało się wybrać osoby, dla której spis i tak byłby pusty.
 */
function collectTaskOwners(milestonesWithCases) {
    const ownersById = new Map();
    for (const { casesWithTasks } of milestonesWithCases || [])
        for (const caseWithTasks of casesWithTasks || []) {
            const taskGroups = [
                caseWithTasks.tasks,
                ...(caseWithTasks.subCasesWithTasks || []).map((s) => s.tasks),
            ];
            for (const tasks of taskGroups)
                for (const task of tasks || [])
                    if (task._owner?.id)
                        ownersById.set(task._owner.id, task._owner);
        }
    return [...ownersById.values()].sort((a, b) => `${a.surname} ${a.name}`.localeCompare(`${b.surname} ${b.name}`, "pl"));
}
function buildTree(contractsWithChildrenInput, targetCaseId, version, options) {
    const caseStatuses = options?.caseStatuses;
    const taskStatuses = options?.taskStatuses;
    const sfx = version !== undefined ? `_v${version}` : "";
    const contractNodes = [];
    const allTasks = [];
    for (const { contract, milestonesWithCases } of contractsWithChildrenInput) {
        const isOurContract = "ourId" in contract;
        const borderColor = isOurContract ? "var(--section-border-our)" : "var(--section-border-other)";
        const contractNode = {
            id: "contract" + contract.id + sfx,
            isInAccordion: true,
            initialExpanded: true,
            borderColor: borderColor,
            level: 1,
            type: "contract",
            childrenNodesType: "milestone",
            selectedObjectRoute: "/contract/",
            repository: TasksGlobalController_1.contractsRepository,
            dataItem: contract,
            title: makeContractTitleHeader(contract),
            children: [],
            AddNewButtonComponent: MilestoneModalButtons_1.MilestoneAddNewModalButton,
            EditButtonComponent: ContractModalButtons_1.ContractEditModalButton,
            editHandler: contractNodeEditHandler,
            shouldRetrieveDataBeforeEdit: true,
            specialRetrieveActionRoute: "contracts",
            isDeletable: false,
            rowActionMenuComponents: contractRowActionMenuComponents,
        };
        const ownersSource = options?.taskOwnersSource?.find((c) => c.contract.id === contract.id)
            ?.milestonesWithCases ?? milestonesWithCases;
        contract._taskOwners = collectTaskOwners(ownersSource);
        contractNodes.push(contractNode);
        for (const { milestone, casesWithTasks } of milestonesWithCases || []) {
            const milestoneContainsTarget = !targetCaseId ||
                (casesWithTasks || []).some(({ caseItem, subCasesWithTasks }) => caseItem.id === targetCaseId ||
                    (subCasesWithTasks || []).some(({ caseItem: sc }) => sc.id === targetCaseId));
            const milestoneNode = {
                id: "milestone" + milestone.id + sfx,
                isInAccordion: true,
                initialExpanded: milestoneContainsTarget,
                level: 2,
                type: "milestone",
                childrenNodesType: "case",
                repository: TasksGlobalController_1.milestonesRepository,
                dataItem: milestone,
                title: react_1.default.createElement(react_1.default.Fragment, null, makeMilestoneTitleLabel(milestone)),
                children: [],
                AddNewButtonComponent: CaseModalButtons_1.CaseAddNewModalButton,
                EditButtonComponent: MilestoneModalButtons_1.MilestoneEditModalButton,
                editHandler: milestoneNodeEditHandler,
                isDeletable: true,
            };
            contractNode.children.push(milestoneNode);
            const allCasesWithTasks = casesWithTasks || [];
            const addCaseNode = (caseItem, tasks, subCasesWithTasks, level, parentNode, isInTypeFolder = false) => {
                const canHaveSubCases = Boolean(caseItem._type._allowsSubCases);
                const caseTasks = (tasks ?? []).filter((t) => taskMatchesStatusFilter(t, taskStatuses));
                const caseNode = {
                    id: "case" + caseItem.id + sfx,
                    level,
                    type: "case",
                    repository: TasksGlobalController_1.casesRepository,
                    dataItem: caseItem,
                    title: react_1.default.createElement(react_1.default.Fragment, null, makeCaseTitleLabel(caseItem, isInTypeFolder)),
                    children: [],
                    leaves: caseTasks.length > 0 ? caseTasks : [],
                    isDeletable: true,
                    AddNewButtonComponent: (canHaveSubCases
                        ? CaseModalButtons_1.CaseAndSubCaseAddButtonGroup
                        : TasksGlobalModalButtons_1.TaskAddNewModalButton),
                    EditButtonComponent: CaseModalButtons_1.CaseEditModalButton,
                    editHandler: (node) => {
                        node.title = react_1.default.createElement(react_1.default.Fragment, null, makeCaseTitleLabel(node.dataItem, isInTypeFolder));
                    },
                };
                parentNode.children.push(caseNode);
                allTasks.push(...caseTasks);
                if (canHaveSubCases) {
                    for (const { caseItem: subCase, tasks: subTasks } of subCasesWithTasks || []) {
                        if (!caseMatchesStatusFilter(subCase, caseStatuses, targetCaseId))
                            continue;
                        const subCaseTasks = (subTasks ?? []).filter((t) => taskMatchesStatusFilter(t, taskStatuses));
                        const subCaseWithParent = { ...subCase, _parentCase: caseItem };
                        const subCaseNode = {
                            id: "subcase" + subCase.id + sfx,
                            level: level + 1,
                            type: "subcase",
                            repository: TasksGlobalController_1.casesRepository,
                            dataItem: subCaseWithParent,
                            title: react_1.default.createElement(react_1.default.Fragment, null, makeCaseTitleLabel(subCase, isInTypeFolder)),
                            children: [],
                            leaves: subCaseTasks,
                            isDeletable: true,
                            AddNewButtonComponent: TasksGlobalModalButtons_1.TaskAddNewModalButton,
                            EditButtonComponent: CaseModalButtons_1.CaseEditModalButton,
                            editHandler: (node) => {
                                node.title = react_1.default.createElement(react_1.default.Fragment, null, makeCaseTitleLabel(node.dataItem, isInTypeFolder));
                            },
                        };
                        caseNode.children.push(subCaseNode);
                        allTasks.push(...subCaseTasks);
                    }
                }
            };
            // Iterujemy sprawy w oryginalnej kolejności z backendu (wg folderNumber).
            // Sprawy unikatowe trafiają wprost pod kamień (poziom 3); sprawy wielokrotne — do
            // folderu typu tworzonego w miejscu PIERWSZEGO wystąpienia danego typu, dzięki czemu
            // foldery i sprawy unikatowe zachowują wspólną, alfabetyczną kolejność.
            const caseTypeFolderNodes = new Map();
            for (const { caseItem, tasks, subCasesWithTasks } of allCasesWithTasks) {
                // Rodzica zachowujemy również, gdy sam odpada przez filtr, ale zawiera
                // podsprawę wskazaną do nawigacji — inaczej nawigacja do niej cicho zawiedzie
                // (strażnik podsprawy w addCaseNode i tak przepuści tylko właściwą podsprawę).
                const containsTargetSubCase = targetCaseId !== undefined &&
                    (subCasesWithTasks || []).some(({ caseItem: sc }) => sc.id === targetCaseId);
                if (!containsTargetSubCase && !caseMatchesStatusFilter(caseItem, caseStatuses, targetCaseId))
                    continue;
                if (caseItem._type.isUniquePerMilestone) {
                    addCaseNode(caseItem, tasks, subCasesWithTasks, 3, milestoneNode);
                    continue;
                }
                const typeId = caseItem._type.id;
                let caseTypeNode = caseTypeFolderNodes.get(typeId);
                if (!caseTypeNode) {
                    caseTypeNode = {
                        id: `casetype${milestone.id}_${typeId}${sfx}`,
                        isInAccordion: true,
                        initialExpanded: true,
                        level: 3,
                        type: "casetype",
                        repository: ContractsController_1.caseTypesRepository,
                        // typ + kamień rodzic — przycisk "Dodaj sprawę" folderu potrzebuje obu
                        dataItem: { ...caseItem._type, _parentMilestone: milestone },
                        title: react_1.default.createElement(react_1.default.Fragment, null, makeCaseTypeTitleLabel(caseItem._type)),
                        children: [],
                        isDeletable: false,
                        AddNewButtonComponent: CaseModalButtons_1.CaseAddNewInTypeFolderButton,
                    };
                    caseTypeFolderNodes.set(typeId, caseTypeNode);
                    milestoneNode.children.push(caseTypeNode);
                }
                addCaseNode(caseItem, tasks, subCasesWithTasks, 4, caseTypeNode, true);
            }
        }
    }
    (options?.leavesRepository ?? TasksGlobalController_1.tasksGlobalRepository).items = allTasks;
    if (options?.collapseEmpty)
        contractNodes.forEach(collapseEmptyBranches);
    return contractNodes;
}
